/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import classNames from 'classnames';
import { Row, Col, Button, Label, Spacer } from '@cleartrip/bento';

import { motion } from 'framer-motion';

import { AutoComplete } from 'components/composite';
import { SrpBanner } from 'components/travelsafe';
import { scrollTo } from 'helper/scrollTo';

import { AirportListContext, FilterContext, StateListContext } from 'context/travelsafe';

import { ReactComponent as Swap } from 'assets/icons/swap.svg';
import { isEmpty } from 'helper/isEmpty';
import Clevertap from 'analytics';

function GlobalFilterDom({ variant, loading, initialAirports, initialStates, successScrollToRef, setShowRoutes }) {
	let query = new URLSearchParams(window.location.search);
	let history = useHistory();

	const [airports, setAirports] = useContext(AirportListContext);
	const [states, setStates] = useContext(StateListContext);

	const [filter, setFilter] = useContext(FilterContext);
	const [origin] = useState(query.get('origin'));
	const [destination] = useState(query.get('destination'));

	const [fromAirport, setFromAirport] = useState({ name: '', code: '' });
	const [toAirport, setToAirport] = useState({ name: '', code: '' });
	const [isValid, setIsValid] = useState(true);
	const [success, setSuccess] = useState(false);
	const [swap, setSwap] = useState(false);

	const popularCities = airports.airportsList.slice(0, 5);

	useEffect(() => {
		if (fromAirport.code && toAirport.code) {
			if (origin && destination && !success && filter.isFilterApplied) {
				submit();
				// getRedirectionUrl()
			}
			if (fromAirport.code === toAirport.code) setIsValid(false);
			else setIsValid(true);
		}
	}, [toAirport.code, fromAirport.code, filter]);

	useEffect(() => {
		if (!loading) {
			if (origin && destination && airports.airportsList.length) {
				let selectedFromAirport = getAirportDetails(origin);
				let selectedToAirport = getAirportDetails(destination);

				if (!isEmpty(selectedFromAirport) && !isEmpty(selectedToAirport)) {
					setFilter({
						...filter,
						from: { code: selectedFromAirport.airportCode, name: selectedFromAirport.name },
						to: { code: selectedToAirport.airportCode, name: selectedToAirport.name },
						isFilterApplied: true,
					});

					setFromAirport({ ...filter.from, code: selectedFromAirport.airportCode, name: selectedFromAirport.name });
					setToAirport({ ...filter.to, code: selectedToAirport.airportCode, name: selectedToAirport.name });
				}
			}
		}
	}, [loading]);

	function getAirportDetails(key) {
		let airport = airports.airportsList.find((airport) => airport.airportCode == key);
		return airport;
	}

	function setFrom(selected) {
		setFromAirport({ code: selected.airportCode, name: selected.name });
		// setFilter({ ...filter, from: { code: selected.airportCode, name: selected.name } });
	}
	function setTo(selected) {
		setToAirport({ code: selected.airportCode, name: selected.name });
		// setFilter({ ...filter, to: { code: selected.airportCode, name: selected.name } });
	}

	function submit() {
		let filteredAirports = filterAirports();
		let filteredStates = filterStates();

		setShowRoutes(false);
		setStates({ ...states, statesList: [...filteredStates] });
		setAirports({ ...airports, airportsList: [...filteredAirports] });
		setSuccess(true);
		setFilter({ ...filter, isFilterApplied: true, from: { ...fromAirport }, to: { ...toAirport } });

		query.set('origin', fromAirport.code);
		query.set('destination', toAirport.code);
		history.push({ search: '?' + query.toString() });
		// setFilter({ ...filter, isFilterApplied: true });

		Clevertap.event('Air_UI_action', {
			action_name: 'route_search',
			action_value: filter.from.code + '_' + filter.to.code,
		});

		scrollTo(successScrollToRef);
		// setTimeout(()=> {
		// 	setFilter({ ...filter, isFilterApplied: false });
		// },1000)
	}

	function filterAirports() {
		let filteredAirports = initialAirports
			.filter((airport) => airport.airportCode === fromAirport.code || airport.airportCode === toAirport.code)
			.sort((a, b) => {
				if (a.airportCode === filter.to.code) return -1;
				else return 1;
			});

		return filteredAirports;
	}

	function filterStates() {
		let destState,
			filteredStates = [];

		initialStates.map((state) => {
			if (state.airportsList) {
				state.airportsList.map((item) => {
					if (item.airportCode === toAirport.code) {
						destState = state.name;
					}
					if (item.airportCode === toAirport.code || item.airportCode === fromAirport.code) filteredStates.push(state);
				});
			}
		});

		filteredStates.sort(function (a, b) {
			if (a.name.toLowerCase() == destState.toLowerCase()) {
				return -1;
			} else {
				return 1;
			}
		});

		let reducedStates = filteredStates.reduce((acc, current) => {
			const x = acc.find((item) => item.name.toLowerCase() === current.name.toLowerCase());
			if (!x) {
				return acc.concat([current]);
			} else {
				return acc;
			}
		}, []);
		return reducedStates;
	}

	function onSwap() {
		setSwap(!swap);
		let temp = fromAirport;
		setFromAirport(toAirport);
		setToAirport(temp);
		// setFilter({ ...filter, from: filter.to, to: temp });
	}

	function onClear() {
		let obj = { name: '', code: '' };
		setShowRoutes(true);
		setSuccess(false);
		setFromAirport(obj);
		setToAirport(obj);
		setFilter({ ...filter, from: obj, to: obj, isFilterApplied: false });
		setAirports({ ...airports, airportsList: [...initialAirports] });
		setStates({ ...states, statesList: [...initialStates] });
		query.set('origin', '');
		query.set('destination', '');
		history.push({ search: '?' + query.toString() });
	}

	function getCtRedirectionUrl() {
		const BASE_URL =
			'https://www.cleartrip.ae/flights/results?origin=&destination=&adults=1&childs=0&class=Economy&depart_date=&from=&infants=0&to=';
		const DAYS_TO_ADD = 14;
		const DEPART_DATE = dayjs().add(DAYS_TO_ADD, 'day').format('DD/MM/YYYY');

		let url = new URL(BASE_URL);
		let params = new URLSearchParams(url.search.slice(1));
		params.set('origin', filter.from.name);
		params.set('destination', filter.to.name);
		params.set('from', filter.from.code);
		params.set('to', filter.to.code);
		params.set('depart_date', DEPART_DATE);
		url.search = params;
		return url.href;
	}

	function getAmazonRedirectionUrl() {
		const BASE_URL = 'https://www.amazon.in/flights/';
		return BASE_URL;
	}

	return (
		<>
			<form>
				<>
					<div className='flex flex-between flex-middle'>
						<Label className='fs-4 c-neutral-700 fw-500'>
							{variant === 'AMAZON' &&
								(filter.isFilterApplied
									? 'Showing information for the following route:'
									: 'Get information specific to your route')}
						</Label>

						{filter.isFilterApplied && (
							<p onClick={onClear} className='ws-nowrap fs-4 c-secondary-500 fw-500 c-pointer'>
								Clear all
							</p>
						)}
					</div>
					<Spacer className='pt-3' />
				</>

				<Row className='flex-middle p-relative'>
					<Col span={9} xs={24}>
						<AutoComplete
							className='fs-4'
							loading={loading}
							inputVal={fromAirport.code && fromAirport.name + ' (' + fromAirport.code + ')'}
							onSelect={setFrom}
							initialList={initialAirports}
							list={airports.airportsList}
							size='lg'
							placeholder='Enter origin airport/city'
						/>
					</Col>
					<div className='ta-center d-none--xs'>
						<motion.div
							className='flex flex-middle flex-center'
							initial={{ rotate: 0 }}
							animate={{ rotate: swap ? 180 : 0 }}
							transition={{
								type: 'spring',
								stiffness: 260,
								damping: 20,
							}}
						>
							<Swap
								height={16}
								width={16}
								onClick={fromAirport.code && toAirport.code ? onSwap : null}
								className={classNames('c-secondary-500 c-pointer', {
									'c-not-allowed c-neutral-400': !fromAirport.code && !toAirport.code,
								})}
							/>
						</motion.div>
					</div>
					<div className='ta-center d-none d-block--xs p-absolute z-10 t-6 r-4 p-2 bc-neutral-200 bg-white ba bw-1 br-100'>
						<motion.div
							className='flex flex-middle flex-center'
							initial={{ rotate: 90 }}
							animate={{ rotate: swap ? 270 : 90 }}
							transition={{
								type: 'spring',
								stiffness: 260,
								damping: 20,
							}}
						>
							<Swap
								height={16}
								width={16}
								onClick={fromAirport.code && toAirport.code ? onSwap : null}
								className={classNames('c-secondary-500 c-pointer', {
									'c-not-allowed c-neutral-400': !fromAirport.code || !toAirport.code,
								})}
							/>
						</motion.div>
					</div>
					<Spacer className='pt-2--xs' />
					<Col span={9} xs={24}>
						<AutoComplete
							className='fs-4'
							loading={loading}
							inputVal={toAirport.code && toAirport.name + ' (' + toAirport.code + ')'}
							onSelect={setTo}
							initialList={initialAirports}
							list={airports.airportsList}
							size='lg'
							placeholder='Enter destination airport/city'
							hasError={!isValid}
						/>
						{!isValid && <p className='p-absolute mt-1 fs-3 c-error-500'>Please select different arrival airport</p>}
					</Col>
					<Col xs={24}>
						<Button
							type='submit'
							className='mt-6--xs'
							type='secondary'
							onClick={() => {
								// setFilter({...filter, isFilterApplied: true})
								submit();
							}}
							full
							disabled={!toAirport.code || !fromAirport.code || !isValid}
						>
							Get informations
						</Button>
					</Col>
				</Row>
			</form>

			<SrpBanner
				isVisible={success}
				filter={filter}
				redirectionUrl={variant === 'AMAZON' ? getAmazonRedirectionUrl() : getCtRedirectionUrl()}
			/>
		</>
	);
}

export default GlobalFilterDom;
